import Col from "@visa/vds/col";
import Grid from "@visa/vds/grid";
import Row from "@visa/vds/row";
import React, { useState, useEffect } from "react";
import MCSSpace from "../../components/MCSSpace";
import { AuthContext } from "../../context/AuthContext";

function VSTSFeeWaiverTermsPage() {

  let [htmlFileString, setHtmlFileString] = useState();
  
  async function fetchHtml(fileName) {
    setHtmlFileString(await (await fetch(fileName)).text());
  }

  const getFeeWaiver = () => {
    return `/feewaiver/faqA.htm`;
  };

  const feeWaiverContent = () => {
    let feeWaiverHtmlPath = getFeeWaiver();    
    feeWaiverHtmlPath = process.env.PUBLIC_URL + feeWaiverHtmlPath;

    // console.log('FW Html Path: ', feeWaiverHtmlPath);
    fetchHtml(feeWaiverHtmlPath);
    return <div dangerouslySetInnerHTML={{ __html: htmlFileString }}></div>;
  };

  useEffect(() => {
    const hashtags = document.getElementsByClassName("MsoEndnoteReference");
    for (let i = 0; i < hashtags.length; i++) {
      let anchortag = hashtags[i].closest("a");
      if (
        anchortag.hash != "" &&
        anchortag.href.indexOf(window.location.pathname) == -1
      )
        anchortag.href = window.location.pathname + anchortag.hash;
    }
  });

  return (
    <AuthContext.Consumer>
      {(currentUser) => (
        <>
          <Grid>
            <Row>
              <Col>
                {currentUser &&
                  currentUser.user &&
                  feeWaiverContent()}
              </Col>
            </Row>
          </Grid>
          <MCSSpace />
        </>
      )}
    </AuthContext.Consumer>
  );
}
export default VSTSFeeWaiverTermsPage;
